import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { AnalysisStrideListItem } from '@sleipai/sleip-models';

// * review Adapted *//
export const loadSingleReview = createAction('[Review] Load Single Review', props<{ reviewId: string }>());

export const addSingleReview = createAction('[Review] Add Single Review', props<{ review: any }>());

export const loadReviews = createAction('[Review] Load Reviews');

export const addReviews = createAction('[Review] Add Reviews', props<{ reviews: any[] }>());

export const loadReviewsSuccess = createAction('[Review] Load Reviews Success', props<{ data: any }>());

export const loadReviewsFailure = createAction('[Review] Load Reviews Failure', props<{ error: any }>());

/** Stride Adapter */

export const addStrideList = createAction('[Review] Add Stride List', props<{ strideList: any }>());

export const updateSingleStride = createAction(
  '[Review] Update Single Stride',
  props<{ update: Update<AnalysisStrideListItem> }>()
);

export const clearStrides = createAction('[Review] Clear Strides');
